import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export async function openSigned(path) {
  const w = window.open("", "_blank");
  try {
    const { data } = await api.get(path);
    if (w) w.location.href = data.url;
    else window.open(data.url, "_blank");
    return data.url;
  } catch (e) {
    if (w) w.close();
    throw e;
  }
}

export function formatApiError(detail) {
  if (detail == null) return "Noe gikk galt. Prøv igjen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
